"use strict";

import { c as _c } from "react/compiler-runtime";
import { RelayEnvironmentProvider, useRelayEnvironment as useRelayEnvironmentImported } from 'react-relay/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export { createEnvironment, getEnvironment, initPersistedEnvironment } from './base-environment';
export { createEnvironmentWithSubscription } from './subscription-environment';
export { GraphError } from './GraphError';
export { createGraphError } from './utils';
export const EnvironmentProvider = _ref => {
  let {
    children,
    environment
  } = _ref;
  return /*#__PURE__*/_jsx(RelayEnvironmentProvider, {
    environment: environment,
    children: children
  });
};
export const useRelayEnvironment = () => {
  const $ = _c(1);
  if ($[0] !== "de95fb1ffc1124b4319bfd08128e14b9e4247993f91d7c46cd88e6002990de8d") {
    for (let $i = 0; $i < 1; $i += 1) {
      $[$i] = Symbol.for("react.memo_cache_sentinel");
    }
    $[0] = "de95fb1ffc1124b4319bfd08128e14b9e4247993f91d7c46cd88e6002990de8d";
  }
  return useRelayEnvironmentImported();
};